import { isPlainObject } from "lodash-es";

const candidateDeviceIdTags = ['deviceId', 'imsi', 'iccid', 'imei', 'devUuid'];

export function getDeviceId(payload) {
  if (isPlainObject(payload)) {
    for (const tag of candidateDeviceIdTags) {
      if (tag in payload) return `${payload[tag]}`;
    }
  }
  // throw new Error(`Invalid payload object`);
}

export function getDecodedTime(decodedMessage) {
  const epochThreshold = 1735707600;  // 2025-01-01T00:00:00Z
  /** @type {string} */
  let dt = decodedMessage.timestamp;  // already ISO string
  const {
    timestamp,
    epochTime,
    secondOfDay,
    minuteOfDay,
  } = decodedMessage.payload;
  let ts = timestamp || epochTime;
  if (typeof ts === 'number') {
    if (ts > epochThreshold) {
      if (ts > (epochThreshold * 1000)) ts = Math.round(ts / 1000);
      dt = new Date(ts * 1000).toISOString();
    }
  } else if (typeof secondOfDay === 'number') {
    if (secondOfDay < 0 || secondOfDay > 86399) {
      console.warn(`Invalid secondOfDay: ${secondOfDay}`);
    }
    ts = (Date.parse(dt.substring(0, 10)) / 1000) + secondOfDay;
    dt = new Date(ts * 1000).toISOString();
  } else if (typeof minuteOfDay === 'number') {
    if (minuteOfDay < 0 || minuteOfDay > 1439) {
      console.warn(`Invalid minuteOfDay: ${minuteOfDay}`);
    }
    ts = (Date.parse(dt.substring(0, 10)) / 1000) + (minuteOfDay * 60);
    dt = new Date(ts * 1000).toISOString();
  }
  return dt.slice(0, 19).replace('T', ' ') + ' UTC';
}
